import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { AuthService } from '@shared/services/auth.service';
import { SnackService } from '@shared/services/snack.service';
import { ApiService } from '@shared/services/api.service';
import { Title } from '@angular/platform-browser';
import { LocaleService } from '@shared/services/locale.service';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { NumbersService } from '@shared/services/numbers.service';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';

@Component({
	selector: 'app-user-reset-password',
	templateUrl: './user-reset-password.component.html',
	styleUrls: ['./user-reset-password.component.scss'],
})
export class UserResetPasswordComponent implements OnInit {
	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private auth: AuthService,
		private snack: SnackService,
		private api: ApiService,
		private title: Title,
		private numbers: NumbersService,
		public locale: LocaleService,
		private cdf: ChangeDetectorRef
	) {}

	public recaptchaVerifier: firebase.auth.RecaptchaVerifier;
	recaptchaWidgetId: number;
	confirmationResult: firebase.auth.ConfirmationResult;
	visible: boolean = true;
	newPassword: any;
	confirmPassword: any;
	loading: boolean = false;
	data: any;
	canExit: boolean = false;
	phone: string;
	showResendOTP: boolean = false;
	showResendOTPTimer: number;

	form: UntypedFormGroup = new UntypedFormGroup({
		otp: new UntypedFormControl('', Validators.required),
	});
	passwordForm: UntypedFormGroup = new UntypedFormGroup({
		newPassword: new UntypedFormControl('', Validators.required),
		confirmPassword: new UntypedFormControl('', Validators.required),
	});

	//function to enter only digits
	isNumberKey(evt): boolean {
		let charCode = evt.which ? evt.which : evt.keyCode;

		if (charCode > 31 && (charCode < 48 || charCode > 57)) {
			return false;
		}

		return true;
	}

	setTimeoutResendOTP() {
		setTimeout(() => {
			this.showResendOTP = true;
		}, 60000);

		this.showResendOTPTimer = 60;
		let timer = setInterval(() => {
			this.showResendOTPTimer = this.showResendOTPTimer - 1;
			if (this.showResendOTPTimer === 0) {
				this.showResendOTP = true;
				this.showResendOTPTimer = undefined;
				clearInterval(timer);
			}
		}, 1000);
	}

	resendOTP(showSnack: boolean = true) {
		this.showResendOTP = false;
		this.loading = true;
		this.visible = true;
		this.sendOtp();
	}

	onKeyUp(field: string) {
		this.form.get(field).setValue(this.numbers.toNumeric(this.form.get(field).value.toString().replace(/\s/g, '')));
	}

	ngOnInit(): void {
		this.title.setTitle(this.locale.translations['user']['user-reset-password']['n246'] + ' | ' + this.locale.translations['header']['n0']);

		this.route.queryParams.subscribe((Params) => {
			this.phone = Params['phone'];
		});

		this.cdf.detectChanges();
		this.fire();
	}

	fire() {
		this.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('sign-in-button', {
			size: 'invisible',
		});
		this.sendOtp();
	}

	sendOtp() {
		this.loading = true;
		firebase
			.auth()
			.signInWithPhoneNumber(localStorage.getItem('prefix') + this.phone.toString().substring(1), this.recaptchaVerifier)
			.then((confirmationResult) => {
				this.canExit = true;

				const verification = this.confirmationResult;
				this.confirmationResult = confirmationResult;
				this.loading = false;
				this.setTimeoutResendOTP();
				// confirmationResult.confirm(verification)
			})
			.catch((err) => {
				this.loading = false;
				this.canExit = true;

				if (err['code'] == 'auth/too-many-requests') {
					this.snack.open(this.locale.translations['user']['user-verify']['n270']);
				} else if (err['code'] == 'auth/invalid-phone-number') {
					this.snack.open(this.locale.translations['logup']['signup']['n231']);
				} else {
					this.snack.open(this.locale.translations['misc']['n174']);
				}
			});
	}

	onCheckOtp() {
		this.loading = true;
		const dataaaa = this.form.controls['otp'].value;
		this.confirmationResult
			.confirm(dataaaa)
			.then((userr) => {
				this.loading = false;

				this.visible = false;
			})
			.catch((err) => {
				this.loading = false;
				this.visible = true;
				this.showResendOTP = true;
				this.snack.open(this.locale.translations['user']['user-verify']['n238']);
			});
	}

	changePassword() {
		this.loading = true;
		if (this.passwordForm.controls['newPassword'].value !== this.passwordForm.controls['confirmPassword'].value) {
			this.loading = false;

			this.snack.open(this.locale.translations['user']['user-profile']['change-password']['n289']);
		} else {
			const formData: FormData = new FormData();

			formData.append('lang', this.locale.lang);
			// // formData.append('otp', this.form.get('otp').value);
			formData.append('phone', this.phone);
			formData.append('newPassword', this.passwordForm.controls['newPassword'].value);

			this.api.resetPassword(formData).subscribe(
				(res) => {
					if (res['status'] === '1') {
						const signInFormData: FormData = new FormData();
						signInFormData.append('lang', this.locale.lang);
						signInFormData.append('phone', this.phone);
						signInFormData.append('password', this.passwordForm.controls['newPassword'].value);
						signInFormData.append('platform', 'web');

						this.api.signIn(signInFormData).subscribe((res) => {
							this.loading = false;

							if (res['status'] === '1') {
								this.auth.login(
									res['response']['userID'],
									res['response']['name'],
									res['response']['phone'],
									res['response']['verified'],
									res['response']['token'],
									res['response']['userType']
								);

								this.router.navigate(['/']);

								this.snack.open(this.locale.translations['user']['user-reset-password']['s24'], 10000);
							}
						});
					} else {
						this.snack.open(this.locale.translations['user']['user-verify']['n238'], 10000);
					}

					this.loading = false;
				},
				(err) => {
					this.snack.open(this.locale.translations['misc']['n174'], 10000);
					this.loading = false;
				}
			);
		}
	}
}
